/**
 * Target specific slot. Used in conjunction with targetSlotInPath function
 */
export const READ_ELEMENT_SLOT_PATH_PREFIX = '♦♦';

/**
 * Always target slot's main element
 */
export const READ_SLOT_PARENT_PATH_PREFIX = '%%';

/**
 * When element has only 1 slot target it's main element.
 */
export const READ_EXCLUSIVE_SLOT_PARENT_PATH_PREFIX = '‰‰';

/**
 * Generates path that can be used to target specific slot when using it in observedField callback function
 * Example: { [`${targetSlotInPath(targetSlotId)}content.visible.viewports`]: value }
 * @param slotId
 */
export const targetSlotInPath = (slotId: string): string =>
  `${READ_ELEMENT_SLOT_PATH_PREFIX}:${slotId}:`;

const testTargetSlotRegexp = new RegExp(
  `^${READ_ELEMENT_SLOT_PATH_PREFIX}:(?<slotId>.*):(?<path>.*)`,
);
export const readTargetSlotIdFromPath = (path: string): { slotId: string; path: string } => {
  const match = testTargetSlotRegexp.exec(path);
  return {
    slotId: match?.groups?.slotId ?? '',
    path: match?.groups?.path ?? '',
  };
};
